/*代码位置/src/directive/permission.js*/
import Vue from 'vue';

// import Util from 'libs/util';
import Config from './../config/index'

import Sto from 'store';

// 权限存储结构
// permissions:[ "KT Admin","sys.role", "sys.user.add", "dict.dictclass.view", "dict.dictclass.add", "sys.permission", "sys.permission.edit", "sys.user.view", "sys"]
// 从cookies里获取保存的权限
// Cookies.set('access', response.data.result.permissions);

// 在mian导入
// import './directive/permission'

// 新增权限指令
Vue.directive('permission', {
	// dom没有刷新
	// bind: function (el, binding, vnode) {
	// 	let cookies = Sto.get(Config.constant.cookie);
	// 	let access = cookies.hasOwnProperty('user') ? cookies.user.permissions : []
		
	// 	let intersectionSet = new Set([...new Set(access)].filter(x => new Set(binding.value).has(x)))
		
	// 	//用来判断用户的权限字符串数组与指令所在元素上的权限字符串数组是否有交集
	// 	if (intersectionSet.size == 0) {
	// 		console.info(el.parentNode)
	// 		// console.info(binding)
	// 		// vnode.key = Math.random()
	// 		// el.remove()
	// 		el.parentNode.removeChild(el);
	// 	}      
	// },
	// dom实时刷新
	inserted: function (el, binding, vnode, oldVnode) {
		let cookies = Sto.get(Config.constant.cookie);
		cookies = cookies ? cookies : {}
		
		let access = cookies.hasOwnProperty('user') ? cookies.user.permissions : []
		
		let intersectionSet = new Set([...new Set(access)].filter(x => new Set(binding.value).has(x)))
		
		//用来判断用户的权限字符串数组与指令所在元素上的权限字符串数组是否有交集
		if (intersectionSet.size == 0) {
			el.remove()
		}   
	}
})

// 限定input控件只能是数字
Vue.directive('numberOnly', {
    bind: function (el, binding, vnode) {
        const handler = function () {
        	console.log(el)
            binding.value = binding.value.replace(/\D+/, '')
        }.bind(this)
        el.addEventListener('input', handler)
    },
    unbind: function (el, binding, vnode) {
        // el.removeEventListener('input', handler)
    }
})


// WEBPACK FOOTER //
// ./src/directive/directives.js